// Import required routing components and page components
import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/Home";
import SongDetailPage from "../pages/SongDetail";

/**
 * Router Component
 * Defines the application's routing structure
 * Routes:
 * - "/" - Home page showing list of songs
 * - "/detail/:songId" - Song detail page (legacy route)
 * - "/song/:songId" - Song detail page (current route)
 */
const Router = props => {
    return(
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/detail/:songId" element={<SongDetailPage />} />
            <Route path="/song/:songId" element={<SongDetailPage />} />
        </Routes>
    )
}

export default Router